import { render, staticRenderFns } from "./TcEventItem.vue?vue&type=template&id=0678e21e&scoped=true&"
import script from "./TcEventItem.vue?vue&type=script&lang=js&"
export * from "./TcEventItem.vue?vue&type=script&lang=js&"
import style0 from "./TcEventItem.vue?vue&type=style&index=0&id=0678e21e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0678e21e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/inventia/Sites/coiico_totem/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0678e21e')) {
      api.createRecord('0678e21e', component.options)
    } else {
      api.reload('0678e21e', component.options)
    }
    module.hot.accept("./TcEventItem.vue?vue&type=template&id=0678e21e&scoped=true&", function () {
      api.rerender('0678e21e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TcEventItem.vue"
export default component.exports